import React from "react";

const Features = () => {
  return (
    <>
      <div className="overflow-hidden">
        <section style={{backgroundColor:'#154d71'}} className="promo-section mt-5 ptb-100">
          <div className="container">
         

    
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7">
                <div className="about-content-left section-heading">
                  <h2 style={{color:'whitesmoke'}}>
                  Thematic Focus
                  </h2>
                <p style={{color:'whitesmoke'}}>Over the years, The Sustainable Institute has built up extensive thematic expertise.
We can therefore contribute to successful project application and/or implementation
with strategic advice, synthesis reports, case studies, mid-term evaluations and
various methodologies and templates. Based on client needs and ambitions, we
research the most interesting and appropriate funding opportunities in international
donor and European programs, leading to an overview of the most relevant funding
sources and practical advice on how to use them. The research can be conducted
either in a general way, matching client’s overall activities and orientation, or it can
be carried out with a specific objective or project in mind. This serves as a very useful
tool in giving an instant overview of the various opportunities and choices that can be
taken in order to match the needs of the client with the relevant EU priorities. This
service is useful for both private and public entities and is particularly valuable for
public entities and SMEs that have limited human resources and lack funding experts
to advise them on EU opportunities.</p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="about-content-right">
                  <img
                    src="assets/img/hero-bg-3.jpg"
                    style={{borderRadius:'20px'}}
                    alt="about us"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
          
        </section>
        
      </div>
    </>
  );
};

export default Features;
